import React, { Fragment } from 'react';
import { MAX_FILE_SIZE_IN_MB, tPrefix } from './constants';
import {
  ActionIconRefresh,
  ButtonRoundTertiary,
  SpacerHorizontal,
  SpacerVertical,
  Typography,
} from '@klarna/bubble-ui';
import { LoaderContainer, LoaderTitle, CenteredRow } from './styledComponents';

type UploadingErrorProps = {
  loading: boolean;
  reUpload: () => void;
  t: TranslatorFunction;
  uploadingFiles: File[];
  uploadingError: number | Error | null;
};

const strong = value => <strong>{value}</strong>;

export const UploadingError = ({
  uploadingFiles,
  uploadingError,
  t,
  loading,
  reUpload,
}: UploadingErrorProps): React.JSX.Element => (
  <>
    {uploadingFiles.map(file => (
      <Fragment key={file.lastModified}>
        <LoaderContainer error={uploadingError}>
          <LoaderTitle>
            <Typography
              textToken="text-style/text/paragraphs/default/regular"
              numberOfLines={1}
              colorToken="colors/text/error"
            >
              {file.name}
            </Typography>

            <CenteredRow>
              <Typography
                textToken="text-style/text/paragraphs/default/regular"
                numberOfLines={1}
                colorToken="colors/text/error"
              >
                {t(`${tPrefix}.errors.${uploadingError === 413 ? 'too_large_file' : 'general'}`, {
                  strong,
                  maxFileSizeMB: `${MAX_FILE_SIZE_IN_MB}`,
                })}
              </Typography>

              <SpacerHorizontal spaceToken="space/150" />

              <ButtonRoundTertiary
                size="small"
                loading={loading}
                onClick={reUpload}
                aria-label="retry upload"
              >
                <ActionIconRefresh />
              </ButtonRoundTertiary>
            </CenteredRow>
          </LoaderTitle>
        </LoaderContainer>
        <SpacerVertical spaceToken="space/150" />
      </Fragment>
    ))}
  </>
);
